import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

export const GetSampleReport = createAsyncThunk(
  "report-generation/sample",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${
          APIS.ReportGeneration.ReportGeneration
        }/average-sample-management?unique_id=${filter?.unique_id ||
          ""}&method_of_testing=${filter?.method_of_testing ||
          ""}&tat=${filter?.tat ||
          ""}&sample_management_status_id=${filter?.sample_management_status_id ||
          ""}&start_date=${filter?.start_date ||
          ""}&end_date=${filter?.end_date || ""}&page=${filter?.page ||
          IDS.PAGE}&per_page=${filter?.perPage ||
          IDS.PERPAGE}&customer_id=${filter?.customer_id || ""}
          `,
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetSampleReportYearly = createAsyncThunk(
  "report-generation-yearly/sample",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${
          APIS.ReportGeneration.ReportGeneration
        }/yearly-average-sample-management?unique_id=${filter?.unique_id ||
          ""}&method_of_testing=${filter?.method_of_testing ||
          ""}&tat=${filter?.tat ||
          ""}&sample_management_status_id=${filter?.sample_management_status_id ||
          ""}&start_date=${filter?.start_date ||
          ""}&end_date=${filter?.end_date || ""}&page=${filter?.page ||
          IDS.PAGE}&per_page=${filter?.perPage ||
          IDS.PERPAGE}&customer_id=${filter?.customer_id ||
          ""}&year=${filter?.year || ""}
          `,
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetInstrumantReport = createAsyncThunk(
  "report-generation/instrumant",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${
          APIS.ReportGeneration.ReportGeneration
        }/instrument-management?unique_id=${filter?.unique_id ||
          ""}&createdAt=${filter?.createdAt ||
          ""}&instrument_name=${filter?.instrument_name ||
          ""}&calibration_status_id=${filter?.calibration_status_id ||
          ""}&calibrated_id=${filter?.calibrated_id ||
          ""}&start_date=${filter?.start_date ||
          ""}&end_date=${filter?.end_date || ""}&page=${filter?.page ||
          IDS.PAGE}&per_page=${filter?.perPage ||
          IDS.PERPAGE}&year=${filter?.year || ""}`,
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetCustomerReport = createAsyncThunk(
  "report-generation/customer",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${
          APIS.ReportGeneration.ReportGeneration
        }/customer-management?unique_id=${filter?.unique_id ||
          ""}&email=${filter?.email ||
          ""}&organization_name=${filter?.organization_name ||
          ""}&contact_person_name=${filter?.contact_person_name ||
          ""}&customer_status_id=${filter?.customer_status_id ||
          ""}&start_date=${filter?.start_date ||
          ""}&end_date=${filter?.end_date || ""}&page=${filter?.page ||
          IDS.PAGE}&per_page=${filter?.per_page ||
          IDS.PERPAGE}&year=${filter?.year || ""}`,
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetQualityControlReport = createAsyncThunk(
  "report-generation/quality-control",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${
          APIS.ReportGeneration.ReportGeneration
        }/quality-control-plan?unique_id=${filter?.unique_id ||
          ""}&email=${filter?.email ||
          ""}&organization_name=${filter?.organization_name ||
          ""}&contact_person_name=${filter?.contact_person_name ||
          ""}&customer_status_id=${filter?.customer_status_id ||
          ""}&page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page ||
          IDS.PERPAGE}&start_date=${filter?.start_date ||
          ""}&end_date=${filter?.end_date || ""}`,
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
export const GetNonConformingReport = createAsyncThunk(
  "report-generation/non-conforming",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${
          APIS.ReportGeneration.ReportGeneration
        }/non-confirming-work?term=${filter?.name || ""}&page=${filter?.page ||
          IDS.PAGE}&per_page=${filter?.per_page ||
          IDS.PERPAGE}&status_id=${filter?.status_id ||
          ""}&department_id=${filter?.department_id ||
          ""}&start_date=${filter?.start_date ||
          ""}&end_date=${filter?.end_date || ""}`,
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetComplanintReport = createAsyncThunk(
  "report-generation/complaint",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${
          APIS.ReportGeneration.ReportGeneration
        }/complaint?unique_id=${filter?.unique_id ||
          ""}&email=${filter?.email ||
          ""}&organization_name=${filter?.organization_name ||
          ""}&contact_person_name=${filter?.contact_person_name ||
          ""}&customer_status_id=${filter?.customer_status_id ||
          ""}&page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page ||
          IDS.PERPAGE}&start_date=${filter?.start_date ||
          ""}&end_date=${filter?.end_date || ""}`,
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetRepeatbilityReport = createAsyncThunk(
  "report-generation/repeatability",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${
          APIS.ReportGeneration.ReportGeneration
        }/process-requirement?unique_id=${filter?.unique_id ||
          ""}&email=${filter?.email ||
          ""}&organization_name=${filter?.organization_name ||
          ""}&contact_person_name=${filter?.contact_person_name ||
          ""}&customer_status_id=${filter?.customer_status_id ||
          ""}&page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page ||
          IDS.PERPAGE}&start_date=${filter?.start_date ||
          ""}&end_date=${filter?.end_date || ""}&title=${filter?.title ||
          ""}&selection_type_id=${filter?.selection_type_id || ""}`,
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetAccuracyReport = createAsyncThunk(
  "report-generation/accuracy",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${
          APIS.ReportGeneration.ReportGeneration
        }/accuracy?unique_id=${filter?.unique_id || ""}&email=${filter?.email ||
          ""}&organization_name=${filter?.organization_name ||
          ""}&contact_person_name=${filter?.contact_person_name ||
          ""}&customer_status_id=${filter?.customer_status_id ||
          ""}&page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page ||
          IDS.PERPAGE}&start_date=${filter?.start_date ||
          ""}&end_date=${filter?.end_date || ""}`,
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetMesurmentUncertinityReport = createAsyncThunk(
  "report-generation/mesurment-uncertinity",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${
          APIS.ReportGeneration.ReportGeneration
        }/measurement-uncertainity?unique_id=${filter?.unique_id ||
          ""}&email=${filter?.email ||
          ""}&organization_name=${filter?.organization_name ||
          ""}&contact_person_name=${filter?.contact_person_name ||
          ""}&customer_status_id=${filter?.customer_status_id ||
          ""}&page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page ||
          IDS.PERPAGE}&start_date=${filter?.start_date ||
          ""}&end_date=${filter?.end_date || ""}`,
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetValidityReport = createAsyncThunk(
  "report-generation/validity",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${
          APIS.ReportGeneration.ReportGeneration
        }/validity-report?term=${filter?.name || ""}&page=${filter?.page ||
          IDS.PAGE}&per_page=${filter?.per_page ||
          IDS.PERPAGE}&validity_type_id=${filter?.validity_type_id ||
          ""}&name=${filter?.name}&start_date=${filter?.start_date ||
          ""}&end_date=${filter?.end_date ||
          ""}&test_type_id=${filter?.test_type_id || ""}`,
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetManagementReport = createAsyncThunk(
  "report-generation/management",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${
          APIS.ReportGeneration.ReportGeneration
        }/management-system?term=${filter?.term || ""}&page=${filter?.page ||
          IDS.PAGE}&per_page=${10 ||
          filter?.per_page ||
          IDS.PERPAGE}&management_system_type_id=${filter?.management_system_type_id ||
          ""}&status_id=${filter?.status_id || ""}&name=${filter?.name ||
          ""}&start_date=${filter?.start_date ||
          ""}&end_date=${filter?.end_date || ""}`,
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetPersnalDetailReport = createAsyncThunk(
  "report-generation/persnal-detail",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${
          APIS.ReportGeneration.ReportGeneration
        }/personnel?term=${filter?.term || ""}&page=${filter?.page ||
          IDS.PAGE}&per_page=${10 ||
          filter?.per_page ||
          IDS.PERPAGE}&management_system_type_id=${filter?.management_system_type_id ||
          ""}&status_id=${filter?.status_id || ""}&name=${filter?.name ||
          ""}&start_date=${filter?.start_date ||
          ""}&end_date=${filter?.end_date || ""}`,
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetExturnalauditReport = createAsyncThunk(
  "report-generation/exturnal-audit",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${
          APIS.ReportGeneration.ReportGeneration
        }/external-audit?term=${filter?.term || ""}&page=${filter?.page ||
          IDS.PAGE}&per_page=${10 ||
          filter?.per_page ||
          IDS.PERPAGE}&management_system_type_id=${filter?.management_system_type_id ||
          ""}&status_id=${filter?.status_id || ""}&name=${filter?.name ||
          ""}&start_date=${filter?.start_date ||
          ""}&end_date=${filter?.end_date || ""}`,
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetEnviromentalReport = createAsyncThunk(
  "report-generation/environmental",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${
          APIS.ReportGeneration.ReportGeneration
        }/environmental?term=${filter?.term || ""}&page=${filter?.page ||
          IDS.PAGE}&per_page=${10 ||
          filter?.per_page ||
          IDS.PERPAGE}&management_system_type_id=${filter?.management_system_type_id ||
          ""}&status_id=${filter?.status_id || ""}&name=${filter?.name ||
          ""}&start_date=${filter?.start_date ||
          ""}&end_date=${filter?.end_date || ""}`,
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetIntermediateReport = createAsyncThunk(
  "report-generation/intermediate",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${
          APIS.ReportGeneration.ReportGeneration
        }/intermediate-check?term=${filter?.term || ""}&page=${filter?.page ||
          IDS.PAGE}&per_page=${10 ||
          filter?.per_page ||
          IDS.PERPAGE}&management_system_type_id=${filter?.management_system_type_id ||
          ""}&status_id=${filter?.status_id || ""}&name=${filter?.name ||
          ""}&start_date=${filter?.start_date ||
          ""}&end_date=${filter?.end_date || ""}`,
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetIntrumentCheckReport = createAsyncThunk(
  "report-generation/intrument-check",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${
          APIS.ReportGeneration.ReportGeneration
        }/instrument-check?term=${filter?.term || ""}&page=${filter?.page ||
          IDS.PAGE}&per_page=${10 ||
          filter?.per_page ||
          IDS.PERPAGE}&management_system_type_id=${filter?.management_system_type_id ||
          ""}&status_id=${filter?.status_id || ""}&name=${filter?.name ||
          ""}&start_date=${filter?.start_date ||
          ""}&end_date=${filter?.end_date || ""}`,
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetExternallyProductReport = createAsyncThunk(
  "report-generation/externally-product",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${
          APIS.ReportGeneration.ReportGeneration
        }/externally-provided?term=${filter?.term || ""}&page=${filter?.page ||
          IDS.PAGE}&per_page=${10 ||
          filter?.per_page ||
          IDS.PERPAGE}&management_system_type_id=${filter?.management_system_type_id ||
          ""}&status_id=${filter?.status_id || ""}&name=${filter?.name ||
          ""}&start_date=${filter?.start_date ||
          ""}&end_date=${filter?.end_date || ""}`,
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetTriningReport = createAsyncThunk(
  "report-generation/trining",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${
          APIS.ReportGeneration.ReportGeneration
        }/training?term=${filter?.term || ""}&page=${filter?.page ||
          IDS.PAGE}&per_page=${10 ||
          filter?.per_page ||
          IDS.PERPAGE}&management_system_type_id=${filter?.management_system_type_id ||
          ""}&status_id=${filter?.status_id || ""}&name=${filter?.name ||
          ""}&start_date=${filter?.start_date ||
          ""}&end_date=${filter?.end_date || ""}`,
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const MetrologicalTracebilityReport = createAsyncThunk(
  "report-generation/metrological-tracebility",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${
          APIS.ReportGeneration.ReportGeneration
        }/metrological-tracebility?term=${filter?.term ||
          ""}&page=${filter?.page || IDS.PAGE}&per_page=${10 ||
          filter?.per_page ||
          IDS.PERPAGE}&management_system_type_id=${filter?.management_system_type_id ||
          ""}&status_id=${filter?.status_id || ""}&name=${filter?.name ||
          ""}&start_date=${filter?.start_date ||
          ""}&end_date=${filter?.end_date || ""}`,
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const ConsumableItemReport = createAsyncThunk(
  "report-generation/consumable-item",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${
          APIS.ReportGeneration.ReportGeneration
        }/consumable-item?term=${filter?.term || ""}&page=${filter?.page ||
          IDS.PAGE}&per_page=${10 ||
          filter?.per_page ||
          IDS.PERPAGE}&management_system_type_id=${filter?.management_system_type_id ||
          ""}&status_id=${filter?.status_id || ""}&name=${filter?.name ||
          ""}&start_date=${filter?.start_date ||
          ""}&end_date=${filter?.end_date || ""}`,
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const OrganizationChartReport = createAsyncThunk(
  "report-generation/Organization-chart",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${
          APIS.ReportGeneration.ReportGeneration
        }/organization-chart?term=${filter?.term || ""}&page=${filter?.page ||
          IDS.PAGE}&per_page=${10 ||
          filter?.per_page ||
          IDS.PERPAGE}&management_system_type_id=${filter?.management_system_type_id ||
          ""}&status_id=${filter?.status_id || ""}&name=${filter?.name ||
          ""}&start_date=${filter?.start_date ||
          ""}&end_date=${filter?.end_date || ""}`,
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
export const Slice = createSlice({
  name: "reportgeneration",
  initialState: {
    sample_data: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(GetSampleReport.pending, (state) => {
        console.log(state, "pending");
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSampleReport.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        console.log(action, "fulfilled");
        state.data = action.payload?.data || {};
      })
      .addCase(GetSampleReport.rejected, (state, action) => {
        console.log(action, "rejected");
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetSampleReportYearly.pending, (state) => {
        console.log(state, "pending");
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSampleReportYearly.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        console.log(action, "fulfilled");
        state.data = action.payload?.data || {};
      })
      .addCase(GetSampleReportYearly.rejected, (state, action) => {
        console.log(action, "rejected");
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetInstrumantReport.pending, (state) => {
        console.log(state, "pending");
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetInstrumantReport.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        console.log(action, "fulfilled");
        state.data = action.payload?.data || {};
      })
      .addCase(GetInstrumantReport.rejected, (state, action) => {
        console.log(action, "rejected");
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(GetCustomerReport.pending, (state) => {
        console.log(state, "pending");
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetCustomerReport.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        console.log(action, "fulfilled");
        state.data = action.payload?.data || {};
      })
      .addCase(GetCustomerReport.rejected, (state, action) => {
        console.log(action, "rejected");
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(GetQualityControlReport.pending, (state) => {
        console.log(state, "pending");
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetQualityControlReport.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        console.log(action, "fulfilled");
        state.data = action.payload?.data || {};
      })
      .addCase(GetQualityControlReport.rejected, (state, action) => {
        console.log(action, "rejected");
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(GetNonConformingReport.pending, (state) => {
        console.log(state, "pending");
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetNonConformingReport.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        console.log(action, "fulfilled");
        state.data = action.payload?.data || {};
      })
      .addCase(GetNonConformingReport.rejected, (state, action) => {
        console.log(action, "rejected");
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetComplanintReport.pending, (state) => {
        console.log(state, "pending");
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetComplanintReport.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        console.log(action, "fulfilled");
        state.data = action.payload?.data || {};
      })
      .addCase(GetComplanintReport.rejected, (state, action) => {
        console.log(action, "rejected");
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetRepeatbilityReport.pending, (state) => {
        console.log(state, "pending");
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetRepeatbilityReport.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        console.log(action, "fulfilled");
        state.data = action.payload?.data || {};
      })
      .addCase(GetRepeatbilityReport.rejected, (state, action) => {
        console.log(action, "rejected");
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetAccuracyReport.pending, (state) => {
        console.log(state, "pending");
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAccuracyReport.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        console.log(action, "fulfilled");
        state.data = action.payload?.data || {};
      })
      .addCase(GetAccuracyReport.rejected, (state, action) => {
        console.log(action, "rejected");
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetMesurmentUncertinityReport.pending, (state) => {
        console.log(state, "pending");
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetMesurmentUncertinityReport.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        console.log(action, "fulfilled");
        state.data = action.payload?.data || {};
      })
      .addCase(GetMesurmentUncertinityReport.rejected, (state, action) => {
        console.log(action, "rejected");
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetValidityReport.pending, (state) => {
        console.log(state, "pending");
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetValidityReport.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        console.log(action, "fulfilled");
        state.data = action.payload?.data || {};
      })
      .addCase(GetValidityReport.rejected, (state, action) => {
        console.log(action, "rejected");
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetManagementReport.pending, (state) => {
        console.log(state, "pending");
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetManagementReport.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        console.log(action, "fulfilled");
        state.data = action.payload?.data || {};
      })
      .addCase(GetManagementReport.rejected, (state, action) => {
        console.log(action, "rejected");
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetExturnalauditReport.pending, (state) => {
        console.log(state, "pending");
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetExturnalauditReport.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        console.log(action, "fulfilled");
        state.data = action.payload?.data || {};
      })
      .addCase(GetExturnalauditReport.rejected, (state, action) => {
        console.log(action, "rejected");
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetPersnalDetailReport.pending, (state) => {
        console.log(state, "pending");
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetPersnalDetailReport.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        console.log(action, "fulfilled");
        state.data = action.payload?.data || {};
      })
      .addCase(GetPersnalDetailReport.rejected, (state, action) => {
        console.log(action, "rejected");
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetEnviromentalReport.pending, (state) => {
        console.log(state, "pending");
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetEnviromentalReport.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        console.log(action, "fulfilled");
        state.data = action.payload?.data || {};
      })
      .addCase(GetEnviromentalReport.rejected, (state, action) => {
        console.log(action, "rejected");
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetIntermediateReport.pending, (state) => {
        console.log(state, "pending");
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetIntermediateReport.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        console.log(action, "fulfilled");
        state.data = action.payload?.data || {};
      })
      .addCase(GetIntermediateReport.rejected, (state, action) => {
        console.log(action, "rejected");
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetIntrumentCheckReport.pending, (state) => {
        console.log(state, "pending");
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetIntrumentCheckReport.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        console.log(action, "fulfilled");
        state.data = action.payload?.data || {};
      })
      .addCase(GetIntrumentCheckReport.rejected, (state, action) => {
        console.log(action, "rejected");
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetExternallyProductReport.pending, (state) => {
        console.log(state, "pending");
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetExternallyProductReport.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        console.log(action, "fulfilled");
        state.data = action.payload?.data || {};
      })
      .addCase(GetExternallyProductReport.rejected, (state, action) => {
        console.log(action, "rejected");
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetTriningReport.pending, (state) => {
        console.log(state, "pending");
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetTriningReport.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        console.log(action, "fulfilled");
        state.data = action.payload?.data || {};
      })
      .addCase(GetTriningReport.rejected, (state, action) => {
        console.log(action, "rejected");
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(ConsumableItemReport.pending, (state) => {
        console.log(state, "pending");
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(ConsumableItemReport.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        console.log(action, "fulfilled");
        state.data = action.payload?.data || {};
      })
      .addCase(ConsumableItemReport.rejected, (state, action) => {
        console.log(action, "rejected");
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(MetrologicalTracebilityReport.pending, (state) => {
        console.log(state, "pending");
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(MetrologicalTracebilityReport.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        console.log(action, "fulfilled");
        state.data = action.payload?.data || {};
      })
      .addCase(MetrologicalTracebilityReport.rejected, (state, action) => {
        console.log(action, "rejected");
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(OrganizationChartReport.pending, (state) => {
        console.log(state, "pending");
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(OrganizationChartReport.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        console.log(action, "fulfilled");
        state.data = action.payload?.data || {};
      })
      .addCase(OrganizationChartReport.rejected, (state, action) => {
        console.log(action, "rejected");
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
